class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
    this.setupFacetsTrigger();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener("focus", this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) =>
      form.addEventListener("reset", this.onFormReset.bind(this))
    );
    this.allSearchInputs.forEach((input) =>
      input.addEventListener("input", this.onInput.bind(this))
    );
  }

  setupFacetsTrigger() {
    const facetsTrigger = document.querySelector(".facets-trigger");
    const facetsWrapper = document.querySelector(".facets-top-wrapper");

    if (facetsTrigger && facetsWrapper) {
      facetsTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        facetsWrapper.classList.toggle("active");
      });

      document.addEventListener("click", (e) => {
        if (
          !facetsTrigger.contains(e.target) &&
          !facetsWrapper.contains(e.target)
        ) {
          facetsWrapper.classList.remove("active");
        }
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          facetsWrapper.classList.remove("active");
        }
      });
    }

    this.setupMobileFacets();
  }

  setupMobileFacets() {
    const mobileFacetsTrigger = document.querySelector(".mobile-facets__open");
    const mobileFacetsWrapper = document.querySelector(
      ".mobile-facets__disclosure"
    );

    if (mobileFacetsTrigger && mobileFacetsWrapper) {
      mobileFacetsTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        mobileFacetsWrapper.setAttribute("open", "");
      });

      const closeButton = document.querySelector(".mobile-facets__close");
      if (closeButton) {
        closeButton.addEventListener("click", (e) => {
          e.preventDefault();
          mobileFacetsWrapper.removeAttribute("open");
        });
      }
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync("", this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: "smooth" });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define("main-search", MainSearch);
